import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Lock } from 'lucide-react'
import { useFeatureFlag } from '@/hooks/useFeatureFlag'
import { Skeleton } from '@deepguide-ai/ui/skeleton'
import { QuestionnaireReviewPanel } from '@/pages/questionnaires/QuestionnaireReviewPanel'

/**
 * #988: individual questionnaire detail/review page. Its own route so the detail
 * view has a shareable URL (`/questionnaires/<id>`) and browser back works. Gated
 * by the `questionnaire` feature flag (guards direct-URL access), mirroring the
 * list page.
 */
export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/questionnaires_/$id',
)({
  component: QuestionnaireDetailPage,
  staticData: { pageHeader: { title: 'Questionnaire', pad: false } },
})

function QuestionnaireDetailPage() {
  const { workspaceId, id } = Route.useParams()
  const navigate = useNavigate()
  const { enabled, loading } = useFeatureFlag('questionnaire')

  const back = () =>
    navigate({ to: '/workspaces/$workspaceId/questionnaires', params: { workspaceId } })

  if (loading) {
    return (
      <div className="space-y-3 p-6">
        <Skeleton className="h-8 w-56" />
        <Skeleton className="h-24 w-full rounded-sm" />
      </div>
    )
  }

  if (!enabled) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 p-16 text-center">
        <Lock className="h-6 w-6 text-text-placeholder" />
        <p className="text-[14px] font-medium text-text-body">Security Questionnaires isn't enabled</p>
        <p className="text-[12px] text-text-placeholder">Contact your administrator to enable this feature.</p>
      </div>
    )
  }

  return (
    <div className="mx-auto w-full max-w-5xl p-6">
      <QuestionnaireReviewPanel id={id} onBack={back} />
    </div>
  )
}
